import React from "react";
import { useSelector } from "react-redux";
import {
    selectAppLoading,
    setAppLoading,
} from "../redux/slices/appSettingsSlice";
import { selectAllActiveInjections } from "../redux/slices/activeInjectionsSlice";
import AppRouter from "./AppRouter";

const ConnectedAppRouter = () => {
    const appLoading = useSelector(selectAppLoading);
    const activeFormInjections = useSelector(selectAllActiveInjections);

    const { favicon } = activeFormInjections;

    const appRouterProps = {
        appLoading,
        favicon,
        setAppLoading,
    };

    return <AppRouter {...appRouterProps} />;
};

export default ConnectedAppRouter;
